// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__gYMVZ","cell":"ColumnAccessor_cell__3epUO","firstCellAccent":"ColumnAccessor_firstCellAccent__2TZNb"};